module.exports = __webpack_public_path__ + "static/img/trifol01-jpeg.574d20e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/LARD/trifol01-jpeg.png
// module id = 66ox
// module chunks = 1